import { Link, useHistory, useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Loader from '../shared/loader';
import stringHelpers from '../../utilities/stringHelpers';
import { Modal } from "react-bootstrap";

const BYELAWS_DVLA_CODE = "00EK";

function Contravention(props) {
    const {contraventionId} = useParams()
    const location = useLocation()
    const [contravention, setContravention] = useState(null);
    const [name, setName] = useState("");
    const [dvlaCode, setDvlaCode] = useState("");
    const [byelawCode, setByelawCode] = useState("");
    const [byelawDescription, setByelawDescription] = useState("");
    const [type, setType] = useState("");
    const [appealReply, setAppealReply] = useState("");
    const [status, setStatus] = useState(false);
    const [reducedChargeAmount, setReducedChargeAmount] = useState(null);
    const [reducedChargeDays, setReducedChargeDays] = useState(null);
    const [fullChargeAmount, setFullChargeAmount] = useState(null);
    const [fullChargeDays, setFullChargeDays] = useState(null);
    const [contraventionListUrl, setContraventionListUrl] = useState("");

    const [isNew, setIsNew] = useState(false);
    const [isInEdit, setIsInEdit] = useState(false);
    const [canSave, setCanSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    const [showActivationReminder, setShowActivationReminder] = useState(false)
    const history = useHistory();

    const submit = function () {
        setIsLoading(true)
        if (canSave) {
            Api.addContravention(
                (data) => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        history.push({
                            pathname: `/organisation/${props.organisationId}/contravention/${data.id}`,
                            state: { showActivationReminder: true }
                        });
                        setErrorMessage("");
                    }
                    setIsLoading(false)
            },
            (error) => {
                setErrorMessage(error)
                setIsLoading(false)
            },
                name, dvlaCode, type, status, appealReply,
                Number(reducedChargeAmount), Number(reducedChargeDays), Number(fullChargeAmount), Number(fullChargeDays),
                byelawCode, byelawDescription,
                props.organisationId,
                props.token
            );
            setIsNew(false);
        }
    };

    const edit = function () {
        setIsLoading(true)
        if (canSave) {
            Api.editContravention(
                (data) => {
                    setIsInEdit(false);
                    setContravention(data);
                    setErrorMessage("");
                    setIsLoading(false)
            },
            (error) => {
                setErrorMessage(error)
                setIsLoading(false)
            },
                name, dvlaCode, type, status, appealReply,
                Number(reducedChargeAmount), Number(reducedChargeDays), Number(fullChargeAmount), Number(fullChargeDays),
                byelawCode, byelawDescription,
                props.organisationId,
                contraventionId,
                props.token
            );
        }
    };

    const getContravention = function () {
        setIsLoading(true)
        Api.getContravention(
            (data) => {
                setContravention(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            props.organisationId,
            contraventionId,
            props.token
        )
    };

    useEffect(() => {
        if (contravention !== null) {
            setName(contravention.name);
            setDvlaCode(contravention.dvlaCode);
            setByelawCode(contravention.byelawCode ?? "");
            setByelawDescription(contravention.byelawDescription ?? "");
            setType(contravention.contraventionType);
            setAppealReply(contravention.appealReply);
            setStatus(contravention.isActive);
            setReducedChargeAmount(contravention.reducedChargeAmount)
            setReducedChargeDays(contravention.reducedChargeDays)
            setFullChargeAmount(contravention.fullChargeAmount)
            setFullChargeDays(contravention.fullChargeDays)
        }
        setErrorMessage("");
    }, [contravention, isInEdit]);

    useEffect(() => {
        if (name === null || name === ""
            || type === null || type === ""
            || appealReply === null || appealReply === ""
            || dvlaCode === null || dvlaCode === ""
            || stringHelpers.isNullOrEmpty(String(reducedChargeAmount))
            || stringHelpers.isNullOrEmpty(String(reducedChargeDays))
            || stringHelpers.isNullOrEmpty(String(fullChargeAmount))
            || stringHelpers.isNullOrEmpty(String(fullChargeDays))
        ) {
            setCanSave(false);

        } else {
            setCanSave(true);
        }
    }, [name, type, dvlaCode, appealReply, reducedChargeAmount, reducedChargeDays, fullChargeAmount, fullChargeDays]);

    useEffect(() => {
        if (contraventionId !== null && contraventionId !== undefined) {
            getContravention();
        } else {
            setIsNew(true);
        }
        setContraventionListUrl("/organisation/" + props.organisationId + "/contravention-settings")
    }, [contraventionId]);

    useEffect(() => {
        if (location.state?.showActivationReminder) {
            setShowActivationReminder(true);
        }
    }, [location]);

    return (<>
        {isLoading && <Loader />}
        {contravention && contravention !== null && <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-3">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0">Contravention - {contravention.name}</h5>
                                    </div>
                                    <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={contraventionListUrl}><i className="fas fa-reply"></i> Back</Link>

                                    <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 dropdown-caret-none mr-3" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                    <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                        <button type="button" className="dropdown-item text-danger" data-toggle="modal" data-target="#deleteModal">
                                            <i className="fas fa-times"></i> Delete Contravention</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-3 ">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0">Details</h5>
                                    </div>
                                    <div className="col-auto">
                                        <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => setIsInEdit(!isInEdit)}>
                                            <i className="fas fa-edit"></i> Edit</button>
                                    </div>
                                </div>
                            </div>
                            {!isInEdit && <>
                                <div className="card-body bg-light border-top details-container">
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Contravention</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{contravention.name}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">DVLA Code</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{contravention.dvlaCode}: {Enums.DvlaCode[contravention.dvlaCode]}</div>
                                    </div>
                                    {contravention.dvlaCode === BYELAWS_DVLA_CODE && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Byelaw Code</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{contravention.byelawCode}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Byelaw Description</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{contravention.byelawDescription}</div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Contravention Type</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{Enums.ContraventionTypes[contravention.contraventionType]}</div>
                                    </div>
                                    <div className="row mb-1">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Appeal Reply</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{contravention.appealReply}</div>
                                    </div>
                                    <div className="row align-items-center mb-3">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-1">Status</p>
                                        </div>
                                        <div className="col-md-6 col-12  ">{contravention.isActive && <i className="fas fa-check text-success"></i>}{!contravention.isActive && <i className="fas fa-times text-danger"></i>}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Reduced Charge Amount</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{stringHelpers.formatDecimal(contravention.reducedChargeAmount, 2, "£")}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Reduced Charge Days</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{stringHelpers.formatDecimal(contravention.reducedChargeDays, 0)}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Full Charge Amount</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{stringHelpers.formatDecimal(contravention.fullChargeAmount, 2, "£")}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Full Charge Days</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{stringHelpers.formatDecimal(contravention.fullChargeDays, 0)}</div>
                                    </div>
                                </div>
                            </>}
                            {isInEdit && <>
                                <div className="card-body bg-light border-top details-container">
                                {errorMessage !== "" && <div className="row">
                                            <div className="offset-md-3 col-md-6">
                                                <p className="error-message">
                                                    {errorMessage}
                                                </p>
                                            </div>
                                        </div>}
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Contravention<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input className="form-control mb-0" type="text" value={name} onChange={(e) => setName(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">DVLA Code<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <select
                                                class="border rounded py-1 px-2 w-100 mb-1"
                                                onChange={ (e) => setDvlaCode(e.target.value) }
                                                value={ dvlaCode }>
                                                <option value="">Select DVLA Code</option>
                                                { Object.entries(Enums.DvlaCode).map(([key, value]) =><option key={ key } value={ key }>{key}: { value }</option>) }
                                            </select>
                                        </div>
                                    </div>
                                    {dvlaCode === BYELAWS_DVLA_CODE && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Byelaw Code</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <input className="form-control mb-0" type="text" maxLength={50} value={byelawCode} onChange={(e) => setByelawCode(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Byelaw Description</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <textarea rows={4} className="form-control mb-0" type="text" value={byelawDescription} onChange={(e) => setByelawDescription(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Contravention Type<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            <div className="form-group mb-0">
                                                <select
                                                    class="border rounded py-1 px-2 w-100 mb-1"
                                                    onChange={ (e) => setType(Number(e.target.value)) }
                                                    value={ type }>
                                                    { Object.entries(Enums.ContraventionTypes).map(([key, value]) =><option key={ key } value={ key }>{ value }</option>) }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Appeal Reply<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <textarea rows={4} className="form-control mb-0" type="text" value={appealReply} onChange={(e) => setAppealReply(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1 mt-1 ">Status</p>
                                        </div>
                                        <div className="col-md-6 col-12 custom-control custom-switch mt-1">
                                            <input className="custom-control-input" type="checkbox" id="switch1" checked={status} onChange={() => setStatus(!status)} />
                                            <label className="custom-control-label ml-3" htmlFor="switch1"></label>
                                            {status && <>Active</>}{!status && <>Deactivated</>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Reduced Charge Amount<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input min={0.00} step={0.01} className="form-control mb-0" type="number" value={ reducedChargeAmount } onChange={ (e) => setReducedChargeAmount(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Reduced Charge Days<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input min={0} className="form-control mb-0" type="number" value={ reducedChargeDays } onChange={ (e) => setReducedChargeDays(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Full Charge Amount<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input min={0.00} step={0.01} className="form-control mb-0" type="number" value={ fullChargeAmount } onChange={ (e) => setFullChargeAmount(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Full Charge Days<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input min={0} className="form-control mb-0" type="number" value={ fullChargeDays } onChange={ (e) => setFullChargeDays(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer border-top ">
                                    <div className="row client-edit-buttons">
                                        <div className="col-12 col-sm-auto ml-auto  pl-0">
                                            <div id="dashboard-actions">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => setIsInEdit(false)}>
                                                    <i className="fas fa-times"></i> Cancel</button>
                                                <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canSave} onClick={() => edit()}>
                                                    <i className="fas fa-check"></i> Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Are you sure you want to delete this contravention?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={() => Api.deleteContravention(() => history.push(contraventionListUrl), props.organisationId, contraventionId, props.token)}>
                                Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            {
                showActivationReminder &&
                <Modal show>
                    <Modal.Header>
                        <Modal.Title>Reminder</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Remember to activate this new contravention within your letter templates
                    </Modal.Body>
                    <Modal.Footer>
                        <button type='button' className='btn btn-sm btn-primary' onClick={() => setShowActivationReminder(false)}>Close</button>
                    </Modal.Footer>
                </Modal>
            }
        </>} {!contravention && isNew && <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-3 ">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0">Create New Contravention</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body bg-light border-top details-container">
                            {errorMessage !== "" && <div className="row">
                                            <div className="offset-md-3 col-md-6">
                                                <p className="error-message">
                                                    {errorMessage}
                                                </p>
                                            </div>
                                        </div>}
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Contravention<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" autoFocus={true} value={name} onChange={(e) => setName(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">DVLA Code<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12">
                                    <select
                                        class="border rounded py-1 px-2 w-100 mb-1"
                                        onChange={ (e) => setDvlaCode(e.target.value) }
                                        value={ dvlaCode }>
                                        <option value="">Select DVLA Code</option>
                                        { Object.entries(Enums.DvlaCode).map(([key, value]) =><option key={ key } value={ key }>{key}: { value }</option>) }
                                    </select>
                                    </div>
                                </div>
                                {dvlaCode === BYELAWS_DVLA_CODE && <>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Byelaw Code</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input className="form-control mb-0" type="text" maxLength={50} value={byelawCode} onChange={(e) => setByelawCode(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Byelaw Description</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <textarea rows={4} className="form-control mb-0" type="text" value={byelawDescription} onChange={(e) => setByelawDescription(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </>}
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Contravention Type<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12 ">
                                        <div className="form-group mb-0">
                                            <select
                                                class="border rounded py-1 px-2 w-100 mb-1"
                                                onChange={ (e) => setType(Number(e.target.value)) }
                                                value={ type }>
                                                <option value="">Select Type</option>
                                                { Object.entries(Enums.ContraventionTypes).map(([key, value]) =><option key={ key } value={ key }>{ value }</option>) }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Appeal Reply<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <div className="form-group mb-1">
                                            <textarea rows={4} className="form-control mb-0" type="text" value={appealReply} onChange={(e) => setAppealReply(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Status</p>
                                    </div>
                                    <div className="col-md-6 col-12 custom-control custom-switch">
                                        <input className="custom-control-input" type="checkbox" id="site-status" checked={status} onChange={() => setStatus(!status)} />
                                        <label className="custom-control-label ml-3" htmlFor="site-status"></label>
                                        {status && <>Active</>}{!status && <>Deactivated</>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Reduced Charge Amount<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <div className="form-group mb-1">
                                            <input min={0.00} step={0.01} className="form-control mb-0" type="number" value={ reducedChargeAmount } onChange={ (e) => setReducedChargeAmount(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Reduced Charge Days<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <div className="form-group mb-1">
                                            <input min={0} className="form-control mb-0" type="number" value={ reducedChargeDays } onChange={ (e) => setReducedChargeDays(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Full Charge Amount<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <div className="form-group mb-1">
                                            <input min={0.00} step={0.01} className="form-control mb-0" type="number" value={ fullChargeAmount } onChange={ (e) => setFullChargeAmount(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Full Charge Days<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <div className="form-group mb-1">
                                            <input min={0} className="form-control mb-0" type="number" value={ fullChargeDays } onChange={ (e) => setFullChargeDays(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer border-top ">
                                <div className="row client-edit-buttons">
                                    <div className="col-12 col-sm-auto ml-auto  pl-0">
                                        <div id="dashboard-actions">
                                            <Link className="btn btn-falcon-default btn-sm" to={contraventionListUrl}><i className="fas fa-times"></i> Cancel</Link>
                                            <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canSave} onClick={() => submit()}>
                                                <i className="fas fa-check"></i> Confirm</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>}
    </>)
}
export default Contravention;